var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 5, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入商品名称查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialName",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 5, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "供应商",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        showSearch: "",
                                        optionFilterProp: "children",
                                        placeholder: "请选择供应商",
                                        allowClear: "",
                                      },
                                      model: {
                                        value: _vm.queryParam.supplierId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "supplierId",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.supplierId",
                                      },
                                    },
                                    _vm._l(_vm.supplierOptions, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(s.supplierName) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  on: { change: _vm.searchQuery },
                                  model: {
                                    value: _vm.queryParam.onlyUnset,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "onlyUnset", $$v)
                                    },
                                    expression: "queryParam.onlyUnset",
                                  },
                                },
                                [_vm._v("只看未设置")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 10, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-bottom": "16px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "setting" },
                          on: { click: _vm.handleBatchSet },
                        },
                        [_vm._v("批量设置供应商")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-popconfirm",
                        {
                          attrs: {
                            title: "确定清除所选商品的全部供应商归属吗?",
                          },
                          on: { confirm: _vm.handleBatchClear },
                        },
                        [
                          _c("a-button", { attrs: { icon: "close" } }, [
                            _vm._v("批量清除归属"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "8px", color: "#999" } },
                    [
                      _vm._v(
                        "已选 " +
                          _vm._s(_vm.selectedMaterialIds.length) +
                          " 个商品"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: _vm.rowKeyOf,
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                      rowSelection: {
                        selectedRowKeys: _vm.selectedRowKeys,
                        onChange: _vm.onSelectChange,
                      },
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "supplier",
                        fn: function (text, record) {
                          return [
                            record.supplierId
                              ? _c(
                                  "span",
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(record.supplierName) +
                                        "\n              "
                                    ),
                                    _vm.isDefaultRow(record)
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "blue" } },
                                          [_vm._v("默认")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("未设置"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _vm.btnEnableList.indexOf(1) > -1
                                ? [
                                    !record.supplierId
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSet(record)
                                              },
                                            },
                                          },
                                          [_vm._v("设置")]
                                        )
                                      : [
                                          !_vm.isDefaultRow(record)
                                            ? _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleSetDefault(
                                                        record
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("设为默认")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "a-popconfirm",
                                            {
                                              attrs: {
                                                title:
                                                  "确定删除该商品的此供应商归属吗?",
                                              },
                                              on: {
                                                confirm: () =>
                                                  _vm.handleRemoveRow(record),
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  style: _vm.isDefaultRow(
                                                    record
                                                  )
                                                    ? ""
                                                    : "margin-left: 8px",
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          ),
                                        ],
                                  ]
                                : _c("span", [_vm._v("-")]),
                            ],
                            2
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: _vm.setTitle,
                    visible: _vm.setVisible,
                    confirmLoading: _vm.setLoading,
                    maskClosable: false,
                  },
                  on: {
                    ok: _vm.handleSetOk,
                    cancel: function ($event) {
                      _vm.setVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "供应商",
                        labelCol: { span: 5 },
                        wrapperCol: { span: 16 },
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            mode: "multiple",
                            showSearch: "",
                            optionFilterProp: "children",
                            placeholder: "请选择供应商（可多选，第一个为默认）",
                          },
                          model: {
                            value: _vm.setSupplierIds,
                            callback: function ($$v) {
                              _vm.setSupplierIds = $$v
                            },
                            expression: "setSupplierIds",
                          },
                        },
                        _vm._l(_vm.supplierOptions, function (s) {
                          return _c(
                            "a-select-option",
                            { key: s.id, attrs: { value: s.id } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(s.supplierName) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#999", "margin-left": "8px" } },
                    [
                      _vm._v(
                        "一个商品可配多个供应商，其中第一个为默认；采购拆分自动分给默认供应商。"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }